import React from 'react';
import Address from 'components/address';
import { display } from 'shared/models/address';
import { connect } from 'react-redux';

class BartenderAddress extends Address {
  render() {
    this.displayAddress = display(this.props.address);

    return (
      <input
        className={`form-control ${this.props.className}`}
        id="address-input"
        type="text"
        defaultValue={this.displayAddress}
        placeholder="Enter Address..."
        disabled={this.props.disabled}
      />
    );
  }

  geolocate() { /* noop */ }
}

function mapStateToProps(state) {
  return { address: state.address };
}

export default connect(mapStateToProps)(BartenderAddress);



// WEBPACK FOOTER //
// ./shared/components/bartender/address.js